import http from "../jslibs/axios/http";

// 风采列表
export const getStyle = (data) => http.get("/v1/cms/article", data);
// 分类列表
export const getCate = (data) => http.get("/v1/cms/ArticleCate", data);
// �新增分类
export const addCate = (data) => http.post("/v1/cms/ArticleCate", data);
// bianji分类
export const editCate = (data, uuid) => http.put(`/v1/cms/ArticleCate/${uuid}`, data);
// 删除分类
export const deleteCate = (uuid) => http.delete(`/v1/cms/ArticleCate/${uuid}`);
// 删除分类
export const setCateStatus = (uuid) => http.get(`/v1/cms/ArticleCateStatus/${uuid}`);

// 风采置顶
export const ArticleTop = (uuid) => http.get(`/v1/cms/ArticleTop/${uuid}`);
// 风采下架
export const ArticleStatus = (uuid) => http.get(`/v1/cms/ArticleStatus/${uuid}`);
// 风采新增
export const addArticle = (data) => http.post(`/v1/cms/article`, data);
// 风采详情
export const actileDetail = (uuid) => http.get(`/v1/cms/article/${uuid}`);
// 风采编辑
export const editArticle = (data, uuid) => http.put(`/v1/cms/article/${uuid}`, data);
// 风采删除
export const delArticle = (uuid) => http.delete(`/v1/cms/article/${uuid}`);

//  轮播图列表
export const getBanner = (data) => http.get("/v1/cms/banner", data);

// 轮播图下架
export const bannerStatus = (uuid) => http.get(`/v1/cms/bannerStatus/${uuid}`);
// 轮播图新增
export const addBanner = (data) => http.post(`/v1/cms/banner`, data);
// 轮播图详情
export const bannerDetail = (uuid) => http.get(`/v1/cms/banner/${uuid}`);
// 轮播图编辑
export const editBanner = (data, uuid) => http.put(`/v1/cms/banner/${uuid}`, data);
// 轮播图删除
export const delBanner = (uuid) => http.delete(`/v1/cms/banner/${uuid}`);

//  优惠券列表
export const couponList = (data) => http.get("/v1/cms/Coupon", data);
// 优惠卷详情
export const couponDetail = (coupon_id) => http.get(`/v1/cms/Coupon/${coupon_id}`);
// 新增优惠卷
export const addCoupon = (data) => http.post(`/v1/cms/Coupon`, data);
// 推送
export const pushCoupon = (data) => http.post(`/v1/cms/CouponUser`, data);
// 编辑优惠卷
export const editCoupon = (data, coupon_id) => http.put(`/v1/cms/Coupon/${coupon_id}`, data);
// 删除优惠卷
export const delCoupon = (coupon_id) => http.delete(`/v1/cms/Coupon/${coupon_id}`);
